<template>
  <remote-opt
    v-if="isForm"
    v-bind="$attrs"
    :name="name"
    v-model="val"
    @input="onInput"
    @fetch="onFetch"
    @change="onChange"
    :labelArr="['id', {
      'label':'name',
      'sub':'brand_name'
    }]"
    :dropLabelArr="['id', 'name']"
    :fetchList="fetchList"
    :srchFilter="regionFilter"
    groupBy="brand_id"
    groupLabel="brand_name"
    sort="status,rank"
    :isTagStyle="multiple && true"
    :multiple="multiple"
  >
  </remote-opt>
  <remote-opt
    v-else
    :isForm="false"
    v-bind="$attrs"
    :name="name"
    data="region_id"
    :labelArr="['region_name']"
    :filterLabelArr="[{
      'label':'name',
      'sub':'brand_name'
    }]"
    inputStore="Region"
    :fields="regionFields"
  >
    <template slot="prepend" slot-scope="scope">
      <el-image
        v-if="typeof scope.row.brand_id !== 'undefined'"
        class="brand-icon"
        :src="getBrandIcon(scope.row.brand_id)"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </template>
  </remote-opt>
</template>

<script>

import { getLabelText } from '@/utils/i18n'
import { regionFilter } from '@/utils/filter'
import { fetchList } from '@/api/region/region'
import { BrandIcon } from '@/enums'

export default {
  name: 'region-opt',
  props: {
    value: null,
    isForm: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'region'
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      val: this.value,
      regionFilter,
      regionMap: {}
    }
  },
  watch: {
    value (v) {
      this.val = v
    }
  },
  computed: {
    regionFields () {
      return [
        {
          'label': this.getLabelText('region', 'name'),
          'fname': 'region_name'
        },
        {
          'label': this.getLabelText('brand', 'id'),
          'fname': 'brand_id'
        },
        {
          'label': this.getLabelText('brand', 'name'),
          'fname': 'brand_name'
        }
      ]
    }
  },
  methods: {
    fetchList,
    getLabelText,
    getBrandIcon (id) {
      return BrandIcon[id]
    },
    onInput () {
      this.$emit('input', this.val)
    },
    onChange (val, region) {
      this.$emit('change', val, region)
    },
    onFetch (v) {
      this.regionMap = v
    }
  }
}

</script>
